"use client";
import {
  useCompositeItem
} from "../__chunks/C6OBNQ4F.js";
import "../__chunks/KSZPJCUA.js";
import "../__chunks/7YKLTEOQ.js";
import {
  useTabScopedContext
} from "../__chunks/32VQXIYR.js";
import "../__chunks/3IEDWLST.js";
import "../__chunks/3D6OCOHF.js";
import "../__chunks/MADQZZRL.js";
import "../__chunks/WAZE6NXP.js";
import "../__chunks/SHA3WOPI.js";
import {
  createElement,
  createHook,
  forwardRef,
  memo
} from "../__chunks/5M6RSQEC.js";
import "../__chunks/EKQEJRUF.js";
import {
  useEvent,
  useId
} from "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../__chunks/4R3V3JGP.js";

// src/tab/tab.ts
import { useCallback } from "react";
import { disabledFromProps, invariant } from "@ariakit/core/utils/misc";
var TagName = "button";
var useTab = createHook(function useTab2(_a) {
  var _b = _a, {
    store,
    accessibleWhenDisabled = true,
    getItem: getItemProp
  } = _b, props = __objRest(_b, [
    "store",
    "accessibleWhenDisabled",
    "getItem"
  ]);
  const context = useTabScopedContext();
  store = store || context;
  invariant(
    store,
    process.env.NODE_ENV !== "production" && "Tab must be wrapped in a TabList component."
  );
  const defaultId = useId();
  const id = props.id || defaultId;
  const dimmed = disabledFromProps(props);
  const getItem = useCallback(
    (item) => {
      const nextItem = __spreadProps(__spreadValues({}, item), { dimmed });
      if (getItemProp) {
        return getItemProp(nextItem);
      }
      return nextItem;
    },
    [dimmed, getItemProp]
  );
  const onClickProp = props.onClick;
  const onClick = useEvent((event) => {
    onClickProp == null ? void 0 : onClickProp(event);
    if (event.defaultPrevented)
      return;
    store == null ? void 0 : store.setSelectedId(id);
  });
  const panelId = store.panels.useState(
    (state) => {
      var _a2;
      return (_a2 = state.items.find((item) => item.tabId === id)) == null ? void 0 : _a2.id;
    }
  );
  const selected = store.useState((state) => !!id && state.selectedId === id);
  props = __spreadProps(__spreadValues({
    id,
    role: "tab",
    "aria-selected": selected,
    "aria-controls": panelId || void 0
  }, props), {
    onClick
  });
  props = useCompositeItem(__spreadProps(__spreadValues({
    store
  }, props), {
    accessibleWhenDisabled,
    getItem,
    shouldRegisterItem: !!defaultId ? props.shouldRegisterItem : false
  }));
  return props;
});
var Tab = memo(
  forwardRef(function Tab2(props) {
    const htmlProps = useTab(props);
    return createElement(TagName, htmlProps);
  })
);
export {
  Tab,
  useTab
};
